<template>
  <b-modal
    id="supportModal"
    :title="'Need support?' | i18n"
    button-size="sm"
    hide-footer
    centered
    content-class="rounded-8"
  >
    <div>
      <p style="margin-bottom: 25px">
        {{ 'Contact us if you need further assistance' | i18n }}
      </p>
      <Input
        v-model="name"
        :placeholder="'name' | i18n"
        :required="true"
      />
      <Input
        v-model="email"
        :placeholder="'email' | i18n"
        :required="true"
      />
      <Textarea
        v-model="message"
        :required="true"
        :placeholder="'message' | i18n"
      />
      <p class="reloadWrapper">
        <b-button
          variant="outline-primary"
          size="lg"
          class="btn-delete-device px-50"
          :disabled="!(email && name && message)"
          @click="submit"
        >
          {{ 'send' | i18n }}
        </b-button>
      </p>
      <p
        v-if="showError"
        style="color: #dc3545; text-align: center"
      >
        {{ errorMessage }}
      </p>
    </div>
    <update-modal />
  </b-modal>
</template>
<script>
import { NotificationMixin, UserMixin } from '../mixins';
import Input from '../v2/components/common/input';
import Textarea from '../v2/components/common/textarea';

export default {
  name: 'LicenseInfo',
  components: { Input, Textarea },
  mixins: [UserMixin, NotificationMixin],
  data: function () {
    return {
      email: '',
      name: '',
      message: '',
      showError: false,
      errorMessage: this.$translate('Problem with send message to support. Please send your question to info@immediate-interaction.com'),
    };
  },
  methods: {
    async submit() {
      this.showError = false;
      try {
        await this.userService.support({
          email: this.email,
          name: this.name,
          message: this.message,
        });
        this.showNotification({
          type: 'success',
          title: this.$translate('support'),
          message: this.$translate('support_success_message'),
        });
        this.$root.$emit('bv::hide::modal', 'supportModal');
      } catch (err) {
        this.showError = true;
        this.showNotification({
          type: 'error',
          title: this.$translate('support'),
          message: this.errorMessage,
        });
      }
    },
  },
};
</script>

<style scoped>
.reloadWrapper {
  display: flex;
  justify-content: center;
}
label {
  color: #7586a5;
}
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
.px-50 {
  padding-left: 50px;
  padding-right: 50px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
